import { render, staticRenderFns } from "./ProgramInfo.vue?vue&type=template&id=b3feb4be&scoped=true&"
import script from "./ProgramInfo.vue?vue&type=script&lang=js&"
export * from "./ProgramInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProgramInfo.vue?vue&type=style&index=0&id=b3feb4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3feb4be",
  null
  
)

export default component.exports